"use strict";

module.exports = function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-util/lib/Dom/contains.js
 ** module id = 1109
 ** module chunks = 0
 **/